import Textarea from "../../../../Core/Fields/Floating/Textarea";

const RegistrationDetails = ({ formData, errors }) => {
  return (
    <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">Registration Details</p>
      </div>
      
      <div className="col-6">
        <div className="mb-3">
          <Textarea
            id="registrationDetails"
            label="Registration Details"
            readOnly
            value={formData.registrationDetails}
            style={{ border: errors.registrationDetails ? "1px solid red" : "",backgroundColor:'#f8f6f6' }}
          />
          <p className="m-0" style={{fontSize:'10px',paddingLeft:'3px'}} >Company registration numbers for your reference. Tax numbers etc.</p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationDetails;